import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { Row, Col, Spin } from 'antd';
import BarChartComponent from '../Charts/BarChartComponent';
import PieChartComponent from '../Charts/PieChartComponent';

const Demographics = ({ onDrillDown }) => {
    const { t } = useTranslation();
    const { demographics, loadingDemographics } = useSelector((state) => state.analytics);

    if (loadingDemographics) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div>
            <Row gutter={[16, 16]}>
                {/* Nationality Distribution */}
                <Col span={12}>
                    <PieChartComponent
                        data={demographics?.nationality || []}
                        dataKey="count"
                        nameKey="label"
                        title={t('analytics.nationalityDistribution')}
                        loading={loadingDemographics}
                        onClick={(data) => {
                            const item = demographics?.nationality?.find(d => d.label === data.name);
                            onDrillDown(`${t('analytics.nationalityDistribution')} - ${data.name}`, "leads", { nationality: data.name }, item?.records);
                        }}
                    />
                </Col>

                {/* City Distribution */}
                <Col span={12}>
                    <BarChartComponent
                        data={demographics?.city || []}
                        xAxisKey="label"
                        yAxisKey="count"
                        title={t('analytics.cityDistribution')}
                        color="#10b981"
                        loading={loadingDemographics}
                        onClick={(data) => {
                            if (data && data.activeLabel) {
                                const item = demographics?.city?.find(d => d.label === data.activeLabel);
                                onDrillDown(`${t('analytics.cityDistribution')} - ${data.activeLabel}`, "leads", { country: data.activeLabel }, item?.records);
                            }
                        }}
                    />
                </Col>

                {/* University Distribution */}
                <Col span={24}>
                    <BarChartComponent
                        data={demographics?.university || []}
                        xAxisKey="label"
                        yAxisKey="count"
                        title={t('analytics.universityDistribution')}
                        color="#3b82f6"
                        loading={loadingDemographics}
                        height={400}
                        onClick={(data) => {
                            if (data && data.activeLabel) {
                                const item = demographics?.university?.find(d => d.label === data.activeLabel);
                                onDrillDown(`${t('analytics.universityDistribution')} - ${data.activeLabel}`, "applications", { key: data.activeLabel }, item?.records);
                            }
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default Demographics;
